export default __webpack_public_path__ + "static/media/Buisness.d5d84f5d.svg";